import React, { Component } from 'react';
import styled from 'styled-components';
import {
    fonts,
    Button,
} from 'prospect-path-base';
import { OnboardingTour, ProgressBar, Section } from 'prospect-path-components';

import ProductsSection from '../../components/home/sections/ProductsSection';
import ActivitySection from '../../components/home/sections/ActivitySection';
import TeamsSection from '../../components/home/sections/TeamsSection';
import WhatsNewSection from '../../components/home/sections/WhatsNewSection';
import { connect } from 'react-redux';
import ProductModal from '../../components/product-management/modals/ProductModal';
import getCustomCopy from '../../actions/GetCustomCopy';

const { display } = fonts;
const { medium } = display;

const HomeContainer = styled.div`
  padding: 5rem 5.1875rem;
  @media screen and (max-width: 768px) {
    padding: 2rem;
  }
`;

const Heading = styled.h2`
  ${medium}
`;

const HomeRow = styled.div`
  display: flex;
  width: 100%;

  @media screen and (max-width: 1150px) {
    flex-direction: column;
  }
`;

const FeedContainer = styled.div`
  flex: 1;
  margin-right: 2.5rem;

  @media screen and (max-width: 768px) {
    margin-right: 0rem;
  }
`;

const SidebarContainer = styled.aside`
  min-width: 19.125rem;
`;

class Home extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isProductModalOpen: false,
        };

        this.openProductModal = this.openProductModal.bind(this);
        this.closeProductModal = this.closeProductModal.bind(this);
        this.getCurrentTeam = this.getCurrentTeam.bind(this);
        this.getCurrentTeamProducts = this.getCurrentTeamProducts.bind(this);
    }

    componentDidMount() {
        this.props.getCustomCopy();
    }

    openProductModal() {
        this.setState({ isProductModalOpen: true });
    }

    closeProductModal() {
        this.setState({ isProductModalOpen: false });
    }
    getCurrentTeam() {
      return this.props.teams.find(team => team.id === this.props.currentTeamId);
    }
    getCurrentTeamProducts() {
      const currentTeam = this.getCurrentTeam();

      if (currentTeam == null || typeof currentTeam === undefined) {
        return [];
      }

      return currentTeam.products;
    }

    render() {
        let currentStep = {
            display: true,
            step: 1,
            summary: 'Add a product',
            progress: 10,
            method: this.openProductModal,
            buttonText: 'Get started',
        };
        // this step must stay hidden until further work is done in teams
        // if (this.props.nextStepProgress.teamHasProduct) {
        //     currentStep = {
        //         display: true,
        //         step: 2,
        //         summary: 'Invite team members',
        //         progress: 50,
        //         method: () => {},
        //         buttonText: 'Continue',
        //     };
        // }
        if (this.props.nextStepProgress.userHasSentInvite) {
            currentStep = {
                display: false,
            };
        }
        if (this.props.nextStepProgress.teamHasProduct) {
          currentStep = {
            display: false,
          }
        };

        return (
          <HomeContainer>
            <Heading>Welcome, {this.props.user.display_name}</Heading>
            <HomeRow>
              <FeedContainer>
                <Section>
                  {currentStep.display && <OnboardingTour
                    step={currentStep.step}
                    summary={currentStep.summary}
                    progress={<ProgressBar progress={currentStep.progress} />}
                    action={
                      <Button
                        onClick={currentStep.method}
                        color="primary"
                        size="small"
                      >
                        {currentStep.buttonText}
                      </Button>
                    }
                  />}
                </Section>
                <ProductModal
                  isOpen={this.state.isProductModalOpen}
                  closeProductModal={this.closeProductModal}
                />

                <ProductsSection
                  products={this.getCurrentTeamProducts()}
                  openProductModal={this.openProductModal}
                />

                <ActivitySection activities={this.props.activities} />
              </FeedContainer>
              <SidebarContainer>
                <WhatsNewSection customCopy={this.props.customCopy} />

                {/* This feature must stay hidden until future release */}
                {/* <TeamsSection /> */}
              </SidebarContainer>
            </HomeRow>
          </HomeContainer>
        );
    }
}

const mapStateToProps = state => ({
    user: state.user,
    teams: state.teams.all,
    currentTeamId: state.teams.currentTeam,
    activities: state.activities,
    customCopy: state.customCopy,
    nextStepProgress: state.nextStepProgress,
    products: state.productManagement.vendorProducts,
});

const mapDispatchToProps = dispatch => ({
    getCustomCopy: () => dispatch(getCustomCopy()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Home);
